<template>
  <div part="concept" class="container is-centered">
    <div class="columns is-centered">
      <div class="column is-12-mobile is-8-tablet is-8-desktop margin">
        <v-img
          class="concept-hero"
          src="@/assets/concept-hero.jpg"
          alt="Thank-you"
          contain
        />
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-12-mobile is-8-tablet is-10-desktop margin">
        <div class="content">
          <p>
            <strong>“The Different World of Well-Being”</strong>, a campaign that celebrates the comfort, balance, and
harmony our products bring to everyday life.
This initiative shines a light on how both our existing and new product collections are
thoughtfully designed to enhance physical and mental well-being, a growing focus in today’s
fast-paced world. From ergonomics to sensory comfort, every detail reflects our commitment
to helping people feel good in their spaces.
As wellness becomes an essential part of modern living, our goal is to show how design,
innovation, and care come together to create a truly Different World of Well-Being.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "./../assets/css/_concept.scss";
.margin {
  margin: auto;
}
.content {
  // max-width: 746px;
  padding: 16px 32px;
  margin: auto;
  line-height: 24px;
}

p {
  font-size: 15px;
  text-align: center;
  text-align-last: center;
}
</style>
<script>
export default {
  created() {
    document
      .getElementsByClassName("main-container")[0]
      .classList.add("concept");
  },
  beforeDestroy() {
    document
      .getElementsByClassName("main-container")[0]
      .classList.remove("concept");
  },
};
</script>
